import { render } from "./MetricSleepQuality.vue?vue&type=template&id=6720506c"
import script from "./MetricSleepQuality.vue?vue&type=script&lang=js"
export * from "./MetricSleepQuality.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__